import { Caption, Flex, useStyles } from '@archipro-design/aria';
import type { ArticleCarouselMobileProps } from '../../type';
import * as S from './ArticlesCarousel.style';
import { Link } from '@remix-run/react';

import { useTracker } from '@archipro-website/tracker';
import ArchizeenTile from '~/modules/tile/component/archizeen-tile/ArchizeenImpressionTile';
import dayjs from 'dayjs';
import { ArticleCarouselPlaceholderMobile } from '../article-tile-skeleton/ArticleCarouselPlaceholder.mobile';

const ArticleCarousel = ({
    articleTiles,
    title,
    articleType,
}: ArticleCarouselMobileProps) => {
    const { css } = useStyles();
    const tracker = useTracker();

    return !articleTiles ? (
        <ArticleCarouselPlaceholderMobile title={title} tileLength={3} />
    ) : (
        <div className={css(S.Wrap)}>
            <Caption className={css(S.TitleWrap)} variant="02" weight="medium">
                {title}
            </Caption>
            <Flex className={css(S.TileSlideOuterWrap)}>
                <Flex className={css(S.TileSlideWrap)}>
                    {articleTiles.map((article) => {
                        const {
                            link,
                            ID,
                            title,
                            image,
                            canEdit: _canEdit,
                            bmEditorLink: _bmEditorLink,
                            professionalID: _professionalID,
                            date,
                            ...rest
                        } = article;
                        return (
                            <div className={css(S.TileSlide)} key={ID}>
                                <ArchizeenTile
                                    key={ID}
                                    as={Link}
                                    to={link}
                                    prefetch="intent"
                                    {...rest}
                                    variant="04"
                                    date={dayjs(date).format('DD MMM YYYY')}
                                    size={'small'}
                                    favouritePosition="card"
                                    title={{
                                        children: title,
                                        maximumLines: 3,
                                    }}
                                    variables={{
                                        tilePadding: 0,
                                    }}
                                    onClick={() => {
                                        tracker.log(
                                            `Article${articleType}Click`,
                                            {
                                                url: new URL(
                                                    window.location.href
                                                ),
                                                targetTracker:
                                                    'archiproTracker',
                                                data: {
                                                    ExtraData: article.ID,
                                                },
                                            }
                                        );
                                    }}
                                    image={{
                                        src: image,
                                        alt: title,
                                    }}
                                    impression={{
                                        professionalID: article.professionalID,
                                        itemID: ID,
                                        type: articleType,
                                    }}
                                    articleId={ID}
                                />
                            </div>
                        );
                    })}
                </Flex>
            </Flex>
        </div>
    );
};

export default ArticleCarousel;
